<div class="page-content">
    <div class="container-fluid">
        <p>bar-chart works!</p>
    </div>
</div>